export const SELF_SERVE_STEP_PATHNAMES = ['/reserve/1', '/reserve/2', '/reserve/3'];

export const RESERVABLE_TYPES = {
  hotDesk: 'HotDesk',
  dedicatedDesk: 'DedicatedDesk',
  sharedOfficeDesk: 'SharedOfficeDesk',
  office: 'Office',
  allAccess: 'AllAccess'
};

export const RESERVABLE_TYPE_TO_MESSAGE = {
  [RESERVABLE_TYPES.hotDesk]: 'hotDesk',
  [RESERVABLE_TYPES.allAccess]: 'allAccess',
  [RESERVABLE_TYPES.dedicatedDesk]: 'dedicatedDesk',
  [RESERVABLE_TYPES.sharedOfficeDesk]: 'dedicatedDesk',
  [RESERVABLE_TYPES.office]: 'privateOffice'
};

export const MARKET_FILTER_DATE_VALUES = {
  thisMonth: 'this_month',
  nextMonth: 'next_month',
  other: 'other'
};

export const MAX_DAYS_AWAY_TO_ALLOW_MOVE_IN = 42;

export const AMENITIES = {
  mailAndPackaging: 'mailAndPackaging',
  privateOfficeConferenceRoomCredits: 'privateOfficeConferenceRoomCredits',
  deskConferenceRoomCredits: 'deskConferenceRoomCredits',
  printingCredits: 'printingCredits',
  furnished: 'furnished'
};

export const FLOORPLAN_ASSET_BASE_URL = 'https://www-floorplan-assets.imgix.net';

export const ALL_ACCESS_PRODUCT_UUID = 'ca04dfa5-b8f4-4c80-b36e-f9547a23f654';
export const ALL_ACCESS_FREE_TRIAL_PRODUCT_UUID = '46b2785e-ff00-4401-82c7-31009328448b';

export const ON_DEMAND_COUNTRY_ALLOWLIST = ['US'];

export const ALL_ACCESS_COUNTRY_ALLOWLIST = ['US', 'CA', 'GB', 'FR'];

export const LOOKUP__COUNTRY_ISO_TO_BILLING_ENTITY = {
  CA: 'cec7a8c2-4a49-4db0-8b89-53c80e2fa83a', // United States Billing Entity
  GB: 'dcb693ea-78d2-4a11-bbf4-11130b3122bf', // Great Britain Billing Entity
  US: 'cec7a8c2-4a49-4db0-8b89-53c80e2fa83a', // United States Billing Entity
  FR: '6f588bf0-e0ff-40dc-b633-844322e52726' // France Billing Entity
};

export const LOOKUP__COUNTRY_ISO_TO_UUID = {
  GB: 'a72000e4-1ea7-11e6-ab4a-0a488af3e541', // United Kingdom Country UUID
  CA: 'a64938f2-1ea7-11e6-ab4a-0a488af3e541', // Canada Country UUID
  FR: '0f1274fe-22d9-11e6-8807-0a488af3e541', // France Country UUID
  BR: '85634b04-31b8-11e6-85d9-0a488af3e541', // Brazil Country UUID
  MX: 'a44de3c2-1ea7-11e6-ab4a-0a488af3e541', // Mexico UUID
  DE: 'a52254cc-1ea7-11e6-ab4a-0a488af3e541', // Germany UUID
  US: 'a4620adc-1ea7-11e6-ab4a-0a488af3e541' // United States UUID
};
